<template>
  <fragment>
    <div class="bootstrap-tagsinput">
      <span class="tag label label-info"  v-for="(v,index) in value" :key="index"
        :style="value[index].type.backgroundColor|tagtypecss" :title="value[index].type.description">
       {{value[index].description}}
       <span
          v-on:click.stop="removeItem(index)"
          title="Rimuovi tag"
          class="tag-remove"
          v-if="setVisibility(value[index])"
        >
          <i class="feather icon-x" />
        </span>
      </span>
      <v-select
          ref="tagselect"
          placeholder="Tags"
          v-model="selectedTag"
          label="name"
          :filterable="false"
          :options="options"
         
          @search="onSearch"
          @input="onSelect"
          @created = "created"
         :pushTags = true
         :create-option = created
        >
          <template slot="no-options">Cerca tra i tags disponibili</template>
          <template slot="option" slot-scope="option">
            <div class="d-center" v-if="option!=null && option.type!=null">
              <span :style="'color:'+option.type.backgroundColor">
                <font-awesome-icon icon="circle"></font-awesome-icon>
              </span>
              {{ option.description }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="d-center" v-if="option!=null && option.type!=null">
              <span :style="'color:'+option.type.backgroundColor">
                <font-awesome-icon icon="circle"></font-awesome-icon>
              </span>
              {{ option.description }}
            </div>
          </template>
        </v-select>
    </div>
   
  </fragment>
</template>
<script>
import axios from "axios";
export default {
  name: "taglist",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: Array,
      required: false,
    },
    types: {
      type: Array,
      required: false,
       default: () => [],
    },
    exclude: {
      type: Array,
      required: false,
       default: () => [],
    },
    readOnlyReserved: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      options: [],
      selectedTag: null,
    };
  },
  methods: {
    created(value){
console.log(value);

    },
     removeItem(index) {
this.value.splice(index,1)
 this.$emit("setChange");
  },
    setVisibility(tag) {
      if (this.readOnly) return false;
      if (this.readOnlyReserved && tag.type.reserved) return false;
      return true;
    },

    onSelect(value) {
     let me = this;
      if (value) {
        if (
          _.findIndex(this.value, function (v) {
            return  v.tagId == value.tagId;
          }) == -1
        ) {
          if(value.code=='newtag'){
          
           this.$swal(
                    {
                        title: ``,
                        html: `Il tag <strong>${value.description}</strong> non è presente. Si desidera crearlo? `,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning-rgba",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                      value.tagId ='8bd55424-ce9b-431e-96c6-f3d724f29ba1';
                       axios.post("tag/generico", value).then((response) =>{
console.log("inserimento",response.data);
me.value.push(response.data);

  setTimeout(function () {
        me.selectedTag = null;
      }, 200);
     
      me.$emit("setChange");

                       });
                    }
                });
          }
          else{
          this.value.push(value);
          }
        }
      }
    
     
      setTimeout(function () {
        me.selectedTag = null;
      }, 200);
     
      this.$emit("setChange");
    },

    onSearch(search, loading) {
      
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      var t = vm.types.join(",");
      var e = vm.exclude.join(",");
      axios.get(`tag/query?q=${escape(search)}&types=${t}&exclude=${e}`).then((res) => {
       vm.options = res.data;
       // vm.options.push({tagId: "new", description: search, type:{backgroundColor:"#F00", description:"Aggiungi nuovo tag"}});
        loading(false);
      });
    }, 350),
  },
 
  remove(v) {
    var me = this;
    var delIndex = -1;
    for (var i = 0; i < this.value.length; i++) {
      if (this.value[i].tagId != v.tagId) {
        delIndex = i;
        break;
      }
    }
    if (delIndex >= 0) {
      this.value.splice(delIndex, 1);
    }
    
  },
};
</script>

<style lang="css">
.tag-remove {
  cursor: pointer;
}

.bootstrap-tagsinput .v-select {
    display: inline-block;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    padding: 0 6px;
    /* margin: 0; */
    width: auto;
    /* max-width: 100%; */
    min-width: 30%;
}
</style>
